<mat-card class="large-card">
    <div class="padding-24">
        <div class="settings-heading">Login Activity</div>
        <div class="padding-16-top-bottom">
            <mat-form-field fluid appearance="outline" class="example-full-width">
                <mat-label>Search</mat-label>

                <input
                    matInput
                    [(ngModel)]="loginActivitySearchTerm"
                    class="search-field"
                    #loginActivitySearchBox
                    (ngModelChange)="filterLoginActivity()"
                    [ngModelOptions]="{ standalone: true }"
                />
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <span
                (click)="exportToExcel(grid)"
                title="Download Excel"
                style="cursor: pointer; padding-left: 15px"
            >
                <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
            </span>
            <div class="float-right">
                <kendo-daterange>
                    <div class="date-input-field">
                        <div class="recordView-label">Start</div>
                        <kendo-dateinput
                            #startDateInput
                            kendoDateRangeStartInput
                            [format]="'MM/dd/yyyy'"
                            [(value)]="range.start"
                            (valueChange)="onChange($event)"
                        ></kendo-dateinput>
                        <span class="k-icon k-i-calendar date-cal" (click)="popup.toggle()"></span>
                    </div>
                    <div class="date-input-field">
                        <div class="recordView-label">End</div>
                        <kendo-dateinput
                            #endDateInput
                            kendoDateRangeEndInput
                            [format]="'MM/dd/yyyy'"
                            [(value)]="range.end"
                            (valueChange)="onChange($event)"
                        ></kendo-dateinput>
                        <span class="k-icon k-i-calendar date-cal" (click)="popup.toggle()"></span>
                    </div>
                    <kendo-daterange-popup #popup [animate]="animation">
                        <ng-template kendoDateRangePopupTemplate>
                            <kendo-multiviewcalendar kendoDateRangeSelection>
                            </kendo-multiviewcalendar>
                        </ng-template>
                    </kendo-daterange-popup>
                </kendo-daterange>
            </div>
        </div>
        <kendo-grid
            #grid="kendoGrid"
            [data]="gridView"
            [skip]="skip"
            [sortable]="sortable"
            [sort]="sort"
            class="lg-kendo-grid"
            [pageable]="pageable"
            [pageSize]="pageSize"
            [scrollable]="scrollable"
            [groupable]="groupable"
            [group]="groups"
            (groupChange)="groupChange($event)"
            (sortChange)="sortChange($event)"
            (pageChange)="pageChange($event)"
        >
            <kendo-grid-column
                *ngIf="view === 'admin'"
                field="clientShortName"
                title="Company"
                [headerClass]="'reports-header'"
                [headerStyle]="{
                    'text-align': 'left',
                    'background-color': '#223540',
                    color: '#FFFFFF',
                    'border-color': '#223540'
                }"
            >
            </kendo-grid-column>

            <kendo-grid-column field="fullName" title="Full Name"> </kendo-grid-column>

            <kendo-grid-column field="loginEmail" title="Email"> </kendo-grid-column>

            <kendo-grid-column field="jobTitle" title="Job Title"> </kendo-grid-column>

            <kendo-grid-column field="lastLoginDateNoTime" title="Login">
                <ng-template kendoGridCellTemplate let-record>
                    {{ record.lastLoginDate | date: 'MM/dd/yyyy hh:mm a' }}
                </ng-template>
                <ng-template
                    kendoGridGroupHeaderTemplate
                    let-group
                    let-field="field"
                    let-value="value"
                >
                    Logged In: {{ value | date: 'MM/dd/yyyy':'UTC' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="exportFileName" [fetchData]="getExcelExportData">
                <kendo-excelexport-column
                    *ngIf="view === 'admin'"
                    field="clientShortName"
                    title="Company"
                >
                </kendo-excelexport-column>
                <kendo-excelexport-column field="fullName" title="Full Name">
                </kendo-excelexport-column>
                <kendo-excelexport-column field="loginEmail" title="Email">
                </kendo-excelexport-column>
                <kendo-excelexport-column field="jobTitle" title="Job Title">
                </kendo-excelexport-column>
                <kendo-excelexport-column field="friendlyTime" title="Login">
                </kendo-excelexport-column>
            </kendo-grid-excel>
        </kendo-grid>
    </div>
</mat-card>
